/* eslint-disable */

export enum ApiVersion {
	Legacy = 0,
	RD3 = 1,
	RD3Experiment = 2,
	
}
